<template>
    <div class="search-wrapper">
        <div class="search-container">
            <div class="search-bar">
                <el-autocomplete
                    ref="searchInput"
                    class="search-input"
                    :class="{'search-active':search}"
                    v-model="search"
                    :fetch-suggestions="querySearch"
                    @keyup.native.enter="handleSearch('init')"
                    @select="handleSelect"
                    placeholder="请输入关键词"
                >
                    <template slot="suffix">
                        <i 
                            v-if="search" 
                            class="el-icon-close clear-icon" 
                            @click="clearSearch"
                        ></i>
                        <i
                            class="el-icon-search search-btn-icon"
                            @click="handleSearch('init')"
                        ></i>
                    </template>
                    <template slot-scope="{ item }">
                        <div>{{ item.value }}</div>
                    </template>
                </el-autocomplete>
            </div>
            
            <div class="search-tabs">
                <el-tabs v-model="filterValue" @tab-click="tabClick">
                    <el-tab-pane 
                        v-for="item in filterOptions" 
                        :key="item.value" 
                        :label="`${item.label}`" 
                        :name="item.value">
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        
        <div class="search-body">
            <!-- 素材列表筛选选项 - 移到条件判断外部 -->
            <div v-if="filterValue === 5" class="material-filter-container">
                <el-dropdown trigger="hover" @command="(val) => handleDropdown('sort', val)" class="custom-dropdown sort-dropdown" placement="bottom-start" :class="{'is-selected': activeTab.sort !== '1'}">
                    <div class="el-dropdown-link">
                        <span>{{ getSortLabel(activeTab.sort) }}</span>
                        <i class="el-icon-error close-icon" v-show="activeTab.sort !== '1'" @click="clearFilter('sort', $event)"></i>
                        <i class="el-icon-arrow-down" v-show="activeTab.sort === '1'"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown" popper-class="find-image-dropdown">
                        <el-dropdown-item command="2" :class="{'is-active': activeTab.sort === '2'}">最近更新</el-dropdown-item>
                        <el-dropdown-item command="5" :class="{'is-active': activeTab.sort === '5'}">免费素材</el-dropdown-item>
                        <el-dropdown-item command="6" :class="{'is-active': activeTab.sort === '6'}">付费素材</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                
                <el-dropdown trigger="hover" @command="(val) => handleDropdown('size', val)" class="custom-dropdown size-dropdown" placement="bottom-start" :class="{'is-selected': activeTab.size !== ''}">
                    <div class="el-dropdown-link">
                        <span>{{ getSizeLabel(activeTab.size, materialSizeList) }}</span>
                        <i class="el-icon-error close-icon" v-show="activeTab.size !== ''" @click="clearFilter('size', $event)"></i>
                        <i class="el-icon-arrow-down" v-show="activeTab.size === ''"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown" popper-class="find-image-dropdown">
                        <el-dropdown-item v-for="item in materialSizeList" :key="item.size" :command="item.size" :class="{'is-active': activeTab.size === item.size}">{{ item.name }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                
                <el-dropdown trigger="hover" @command="(val) => handleDropdown('twoSort', val)" class="custom-dropdown price-dropdown" placement="bottom-start" :class="{'is-selected': activeTab.twoSort !== ''}">
                    <div class="el-dropdown-link">
                        <span>{{ getTwoSortLabel(activeTab.twoSort) }}</span>
                        <i class="el-icon-error close-icon" v-show="activeTab.twoSort !== ''" @click="clearFilter('twoSort', $event)"></i>
                        <i class="el-icon-arrow-down" v-show="activeTab.twoSort === ''"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown" popper-class="find-image-dropdown">
                        <el-dropdown-item command="2" :class="{'is-active': activeTab.twoSort === '2'}">由低到高</el-dropdown-item>
                        <el-dropdown-item command="1" :class="{'is-active': activeTab.twoSort === '1'}">由高到低</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

                <el-dropdown trigger="hover" class="custom-dropdown price-dropdown" placement="bottom-start" :class="{'is-selected': activeTab.colorList && activeTab.colorList.length > 0}">
                    <div class="el-dropdown-link color-dropdown">
                        <b><i class="color-icon" :class="{'white-color': selectedColor.color === '#FFFFFF'}" v-show="activeTab.colorList.length" :style="{ backgroundColor: selectedColor.color }"></i>{{ selectedColor.name }}</b>
                        <i class="el-icon-error close-icon" v-show="activeTab.colorList.length" @click="clearColor($event)"></i>
                        <i class="el-icon-arrow-down" v-show="!activeTab.colorList.length"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown" popper-class="find-image-dropdown" >
                        <div class="color-list">
                            <span class="color-item" @click="setColor(item.id)" :class="{'active': activeTab.colorList.includes(item.id)}" v-for="item in colorList" :key="item.id">
                                <span class="color-item-color" :class="{'white-color': item.color === '#FFFFFF'}" :style="{ backgroundColor: item.color }"></span>
                            </span>
                        </div>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>

            <!-- 图片列表筛选选项 - 移到条件判断外部 -->
            <div v-if="filterValue === 7" class="material-filter-container">
                <el-dropdown trigger="hover" @command="(val) => handleDropdown('sort', val)" class="custom-dropdown sort-dropdown" placement="bottom-start" :class="{'is-selected': activeTab.sort !== '1'}">
                    <div class="el-dropdown-link">
                        <span>{{ getSortLabel(activeTab.sort) }}</span>
                        <i class="el-icon-error close-icon" v-show="activeTab.sort !== '1'" @click="clearFilter('sort', $event)"></i>
                        <i class="el-icon-arrow-down" v-show="activeTab.sort === '1'"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown" popper-class="find-image-dropdown">
                        <el-dropdown-item command="2" :class="{'is-active': activeTab.sort === '2'}">最近更新</el-dropdown-item>
                        <el-dropdown-item command="5" :class="{'is-active': activeTab.sort === '5'}">免费素材</el-dropdown-item>
                        <el-dropdown-item command="6" :class="{'is-active': activeTab.sort === '6'}">付费素材</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                
                <el-dropdown trigger="hover" @command="(val) => handleDropdown('size', val)" class="custom-dropdown size-dropdown" placement="bottom-start" :class="{'is-selected': activeTab.size !== ''}">
                    <div class="el-dropdown-link">
                        <span>{{ getSizeLabel(activeTab.size, imageSizeList) }}</span>
                        <i class="el-icon-error close-icon" v-show="activeTab.size !== ''" @click="clearFilter('size', $event)"></i>
                        <i class="el-icon-arrow-down" v-show="activeTab.size === ''"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown" popper-class="find-image-dropdown">
                        <el-dropdown-item v-for="item in imageSizeList" :key="item.size" :command="item.size" :class="{'is-active': activeTab.size === item.size}">{{ item.name }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                
                <el-dropdown trigger="hover" @command="(val) => handleDropdown('price', val)" class="custom-dropdown price-dropdown" placement="bottom-start" :class="{'is-selected': activeTab.price !== ''}">
                    <div class="el-dropdown-link">
                        <span>{{ getTwoSortLabel(activeTab.price) }}</span>
                        <i class="el-icon-error close-icon" v-show="activeTab.price !== ''" @click="clearFilter('price', $event)"></i>
                        <i class="el-icon-arrow-down" v-show="activeTab.price === ''"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown" popper-class="find-image-dropdown">
                        <el-dropdown-item command="2" :class="{'is-active': activeTab.price === '2'}">由低到高</el-dropdown-item>
                        <el-dropdown-item command="1" :class="{'is-active': activeTab.price === '1'}">由高到低</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

                <el-dropdown trigger="hover" @command="(val) => handleDropdown('proportion', val)" class="custom-dropdown price-dropdown" placement="bottom-start" :class="{'is-selected': activeTab.proportion !== ''}">
                    <div class="el-dropdown-link">
                        <span>{{ getProportionLabel(activeTab.proportion) }}</span>
                        <i class="el-icon-error close-icon" v-show="activeTab.proportion !== ''" @click="clearFilter('proportion', $event)"></i>
                        <i class="el-icon-arrow-down" v-show="activeTab.proportion === ''"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown" popper-class="find-image-dropdown">
                        <el-dropdown-item command="0" :class="{'is-active': activeTab.proportion === '0'}">横图</el-dropdown-item>
                        <el-dropdown-item command="1" :class="{'is-active': activeTab.proportion === '1'}">竖图</el-dropdown-item>
                        <el-dropdown-item command="2" :class="{'is-active': activeTab.proportion === '2'}">方图</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

                <el-dropdown trigger="hover" class="custom-dropdown price-dropdown" placement="bottom-start" :class="{'is-selected': activeTab.colorList && activeTab.colorList.length > 0}">
                    <div class="el-dropdown-link color-dropdown">
                        <b><i class="color-icon" :class="{'white-color': selectedColor.color === '#FFFFFF'}" v-show="activeTab.colorList.length" :style="{ backgroundColor: selectedColor.color }"></i>{{ selectedColor.name }}</b>
                        <i class="el-icon-error close-icon" v-show="activeTab.colorList.length" @click="clearColor($event)"></i>
                        <i class="el-icon-arrow-down" v-show="!activeTab.colorList.length"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown" popper-class="find-image-dropdown" >
                        <div class="color-list">
                            <span class="color-item" @click="setColor(item.id)" :class="{'active': activeTab.colorList.includes(item.id)}" v-for="item in colorList" :key="item.id">
                                <span class="color-item-color" :class="{'white-color': item.color === '#FFFFFF'}" :style="{ backgroundColor: item.color }"></span>
                            </span>
                        </div>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>

            <EmptyPage :height="588" :loading="loading" v-if="list.length === 0" />
            <div v-else>
                <!-- <div class="search-result-total">共找到 {{ total }} 个结果</div> -->

                <div class="search-result-list">
                    <!-- 工具列表 -->
                    <div class="search-list" v-if="filterValue === 3">
                        <div class="search-list-item" v-for="(item, index) in list" :key="index">
                            <ToolCard size="mini" :data="item" @handleCard="openToolDetail(item)"></ToolCard>
                        </div>
                    </div>

                    <!-- 设计师列表 -->
                    <div class="designer-list" v-else-if="filterValue === 4">
                        <div class="designer-list-item" v-for="(item, index) in list" :key="index">
                            <UserCard :data="item" :showFollowBtn="false"></UserCard>
                        </div>
                    </div>

                    <!-- 素材列表 -->
                    <div class="material-list" v-else-if="filterValue === 5">
                        <div class="material-list-item" v-for="(item, index) in list" :key="index">
                            <MaterialCard :material="item" @set-material="setMaterial"/>
                        </div>
                    </div>

                    <!-- 源码列表 -->
                    <div class="peoject-list" v-else-if="filterValue === 6">
                        <div class="peoject-list-item" v-for="(item, index) in list" :key="index">
                            <ServiceCard :sourceCode="item" @set-source-code="setSourceCode" />
                        </div>
                    </div>

                    <!-- 项目案例列表 -->
                    <div class="peoject-list" v-else-if="filterValue === 8">
                        <div class="peoject-list-item" v-for="(item, index) in list" :key="index">
                            <ProjectCaseCard :data="item" @set-project-case="setProjectCase" />
                        </div>
                    </div>

                    <!-- 图片列表 -->
                    <div v-else-if="filterValue === 7">
                        <ImageList 
                            :externalImageList="list" 
                            :externalLoading="loading" 
                            :externalScrollLoading="scrollLoading"
                            :useInternalLoading="false"
                        />
                    </div>

                    <!-- 课程列表 -->
                    <div class="course-container" v-else-if="filterValue === 9">
                        <course-list 
                            :course-list="list" 
                            :loading="scrollLoading" 
                            :pagination="false"
                        />
                    </div>

                    <!-- 全部列表 -->
                    <div class="search-list" v-else>
                        <div class="search-list-item" v-for="(item, index) in list" :key="index">
                            <Card :data="item" @openDetail="openDetail" @openUserDetail="openUserDetail"></Card>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <material-detail :material.sync="material"  @updateMaterialList="updateMaterialList"></material-detail> -->
    </div>
</template>

<script>
import { mapState } from 'vuex';
import EmptyPage from '@/components/EmptyPage';
import UserCard from '@/views/components/UserCard';
import Card from '@/views/components/Card';
import ToolCard from '@/views/components/ToolCard';
import MaterialCard from '@/views/Material/components/MaterialCard';
import MaterialDetail from '@/views/Material/components/MaterialDetail';
import ServiceCard from '@/views/SourceCode/components/SourceCodeCard';
import ProjectCaseCard from '@/views/ProjectCase/components/ServiceCard';
import ImageCard from '@/views/FindImage/components/ImageCard';
import CourseList from '@/components/CourseList';
import ImageList from '@/views/FindImage/components/ImageList';

import { openWindow } from '@/utils/utils';
import { viewTool } from '@/api/tool';
import { getWorkSearchList, getArticleSearchList, getToolSearchList, getUserSearchList, getMaterialSearchList, getSearchCount, getImageSearchList, getProjectCaseList, getCourseList, getSearchRecommend } from '@/api/search';
import { getSourceCodeList } from '@/api/sourceCode';
import { getSearchDefaultKey } from '@/api/home';
import { getSizeList, getMaterialColorList } from '@/api/material';
import { getImageSizeList, getColorList } from '@/api/findImage/index';

export default {
    name: 'Search',
    components: {
        EmptyPage,
        Card,
        ToolCard,
        UserCard,
        MaterialCard,
        MaterialDetail,
        ServiceCard,
        ProjectCaseCard,
        ImageCard,
        CourseList,
        ImageList
    },
    inject: ['backTop'],
    data: () => ({
        search: '',
        searchKey:"",
        searchKeyPlaceholder: '世界地图',
        searchKeyIndex: 0,
        searchDefaultKey: [
            '世界地图' // 默认值，将通过API获取完整列表
        ],
        searchKeyTimer: null,
        filterValue: 5,
        filterOptions: [
            { label: '素材', routeNameList: ['FreeMaterial','FreeMaterialDetail'], value: 5, count: 0 },
            // { label: '图片', routeNameList: ['FindImage', 'FindImageWithFormat', 'FindImageDetail'], value: 7, count: 0 },
            { label: '作品', routeNameList: ['Works', 'Home', 'WorksDetail'], value: 1, count: 0 },
            { label: '经验', routeNameList: ['Experience', 'ExperienceDetail'], value: 2, count: 0 },
            { label: '工具', routeNameList: ['Tool'], value: 3, count: 0 },
            { label: '源码', routeNameList: ['SourceCode', 'SourceCodeWithTechId','SourceCodeDetail'], value: 6, count: 0 },
            { label: '案例', routeNameList: ['ProjectCase', 'ProjectCaseDetail'], value: 8, count: 0 },
            { label: '课程', routeNameList: ['Courses','CoursesDetail'], value: 9, count: 0 },
            { label: '设计师', routeNameList: ['User'], value: 4, count: 0 },
        ],
        loading: true,
        scrollLoading: false,
        total: 0,
        pageSize: 20,
        pageNum: 1,
        pages: 1,
        list: [],
        categoryList: [
            { label: '原创', value: 3 },
            { label: '转载', value: 1 },
            { label: '自译', value: 2 }
        ],
        material: null,
        // 新增筛选相关数据
        activeTab: {
            sort: '1',
            size: '',
            twoSort: '',
            price: '',
            proportion: '',
            colorList: []
        },
        colorList:[
            { id: '1', name: '红色', color: '#EE4A4A' },
            { id: '2', name: '蓝色', color: '#0E6BF6' },
            { id: '3', name: '橙色', color: '#FD8616' },
            { id: '4', name: '紫色', color: '#7E03F9' },
            { id: '5', name: '黄色', color: '#FFEB3B' },
            { id: '6', name: '黑色', color: '#000000' },
            { id: '7', name: '绿色', color: '#029E78' },
            { id: '8', name: '白色', color: '#FFFFFF' },
            { id: '9', name: '青色', color: '#0AF4FC' },
            { id: '11', name: '灰色', color: '#888888' }
        ],
        materialSizeList:[],
        imageSizeList:[]
    }),
    computed: {
        ...mapState('app', ['scrollStatus']),
        selectedColor() {
            if (!this.activeTab.colorList || this.activeTab.colorList.length === 0) {
                return { name: '颜色', color: 'transparent' };
            }
            const found = this.colorList.find(item => this.activeTab.colorList.includes(item.id));
            return found || { name: '颜色', color: 'transparent' };
        }
    },
    watch: {
        filterValue:{
            handler(){
                console.log('filterValue: ', this.filterValue);
                this.handleSearch('init');
            },
        },
        scrollStatus() {
            if (!this.scrollLoading) {
                this.scroll();
            }
        },
    },
    mounted() {
        const { search, routeName, category } = this.$route.query;
        console.log('search: ', search);
        if (search) {
            this.search = search;
            this.searchKey = this.search;
        }
        
        // 获取搜索关键词并启动轮播
        // this.getSearchKeywords();
        
        // 记录是否已通过category设置了filterValue
        let filterValueSet = false;
        
        // 如果URL中有分类参数，设置对应的filterValue
        if (category) {
            this.filterValue = parseInt(category);
            filterValueSet = true;
        }
        
        if (routeName) {
            // 根据URL参数中的routeName重新排序filterOptions，但不覆盖已设置的filterValue
            this.reorderFilterOptions(routeName, filterValueSet);
        }
        
        this.initPageParams();
        if(this.filterValue === 5) {
            this.getData('init');
        } else if(this.filterValue === 7) {
            this.getData('init');
            this.getColorList();
        }
        // 加载图片筛选所需的尺寸和颜色数据
        this.getImageSizeList();
        // 加载尺寸和颜色数据
        this.getSizeList();
        this.getColorList();
    },
    beforeDestroy() {
        // 清除轮播定时器
        if (this.searchKeyTimer) {
            clearInterval(this.searchKeyTimer);
            this.searchKeyTimer = null;
        }
    },
    methods: {
        // 获取搜索默认关键词
        async getSearchKeywords() {
            try {
                const { code, data } = await getSearchDefaultKey();
                if (code === 0 && data && Array.isArray(data) && data.length > 0) {
                    this.searchDefaultKey = data;
                    this.searchKeyPlaceholder = this.searchDefaultKey[0];
                }
                // 启动搜索关键词轮播
                this.startSearchKeyRotation();
            } catch (error) {
                console.error('获取搜索关键词失败:', error);
                // 出错时仍启动轮播，使用默认值
                this.startSearchKeyRotation();
            }
        },
        // 启动搜索关键词轮播
        startSearchKeyRotation() {
            this.searchKeyTimer = setInterval(() => {
                this.searchKeyIndex = (this.searchKeyIndex + 1) % this.searchDefaultKey.length;
                this.searchKeyPlaceholder = this.searchDefaultKey[this.searchKeyIndex];
            }, 5000);
        },
        // 重新排序filterOptions
        reorderFilterOptions(routeName, keepFilterValue = false) {
            console.log('routeName: ', routeName);
            // 查找匹配的filterOption
            const matchIndex = routeName ? 
                this.filterOptions.findIndex(option => 
                    option.routeNameList && option.routeNameList.includes(routeName)
                ) : -1;
            
            if (matchIndex > 0) {
                // 如果找到匹配项且不在第一位，则将其移到第一位
                // const matchItem = this.filterOptions.splice(matchIndex, 1)[0];
                // this.filterOptions.unshift(matchItem);
                
                // 只有在没有设置keepFilterValue时才更新filterValue
                if (!keepFilterValue) {
                    this.filterValue = this.filterOptions[matchIndex].value;
                }
            } else if (matchIndex === -1) {
                // 没有匹配到，确保素材搜索在第一位
                // const materialIndex = this.filterOptions.findIndex(option => 
                //     option.routeNameList && option.routeNameList.includes('FreeMaterial')
                // );
                
                // if (materialIndex > 0) {
                //     const materialItem = this.filterOptions.splice(materialIndex, 1)[0];
                //     this.filterOptions.unshift(materialItem);
                // }
                
                // 只有在没有设置keepFilterValue时才更新filterValue
                if (!keepFilterValue) {
                    this.filterValue = 5;
                }
            } else if (!keepFilterValue) {
                this.filterValue = 5;
            }
            
            console.log('重排后的filterOptions:', this.filterOptions);
        },
        /**
		 * 回填素材列表（用户可能在详情页收藏或下载，列表需同步更新）
		 */
		updateMaterialList(newMaterialInfo) {
			// 有id时更新指定素材信息
			if (newMaterialInfo.id) {
				const material = this.list.find(material => material.id === newMaterialInfo.id);
				Object.assign(material, newMaterialInfo);
			} else {
				// 否则批量更新
				this.list.forEach(material => Object.assign(material, newMaterialInfo));
			}
		},
        // 实现与Nav.vue相同的querySearch功能
        async querySearch(queryString, cb) {
            if (queryString === '') {
                cb([]);
                return;
            }
            let params = {
                pageSize: 5,
                pageNum: 1,
                title: queryString,
            };
            const { code, data } = await getSearchRecommend(params);
            if (code === 0) {
                const list = data.map((item) => {
                    return {
                        value: item.keyword,
                        type: item.type
                    };
                });
                cb(list);
            } else {
                cb([]);
            }
        },
        clearSearch() {
            this.search = '';
            this.searchKey = '';
            this._searchKeyPlaceholder = this.searchKeyPlaceholder;
            this.searchKeyPlaceholder = '';
            this.list = [];
            this.handleSearch()
            // 更新URL参数但不触发搜索
            const query = { 
                category: this.filterValue.toString()
            };
            if (this.$route.query.routeName) {
                query.routeName = this.$route.query.routeName;
            }
            
            this.$router.push({
                name: 'Search',
                query: query
            });
        },
        handleSelect(item) {
            // 处理选择建议项的逻辑
            this.search = item.value;
            const routerMap = {
                'DESIGN_WORKS': 1,
                'EXPERIENCE': 2,
                'SOURCE_CODE': 6,
                'MATERIAL': 5,
                'COURSE': 9,
            }
            if(this.filterValue === routerMap[item.type]) {
                this.handleSearch()
            } else {
                this.filterValue = routerMap[item.type]
            }
            
        },
        tabClick() {
            // 点击tab切换时更新URL参数
            this._searchKeyPlaceholder = this.searchKeyPlaceholder;
            this.searchKeyPlaceholder = '';
            this.updateUrlWithCategory();
        },
        updateUrlWithCategory() {
            // 构建查询参数，保留search和routeName参数
            const query = { 
                search: this.search,
                category: this.filterValue.toString()
            };
            if (this.$route.query.routeName) {
                query.routeName = this.$route.query.routeName;
            }
            
            this.$router.push({
                name: 'Search',
                query: query
            });
        },
        handleSearch(type) {
            this.loading = true;
            this.list = [];
            
            // 如果搜索框为空，使用当前轮播的关键词
            const searchTerm = this.search.trim() 
            // const searchTerm = this.searchKeyPlaceholder;
            this.searchKeyPlaceholder = this._searchKeyPlaceholder;
            
            // 构建查询参数，保留routeName参数，添加分类参数
            const query = { 
                search: searchTerm,
                category: this.filterValue.toString()
            };
            if (this.$route.query.routeName) {
                query.routeName = this.$route.query.routeName;
            }
            
            this.$router.push({
                name: 'Search',
                query: query
            });
            
            this.searchKey = searchTerm;
            this.search = searchTerm;
            this.initPageParams();
            this.getData(type);
        },
        initPageParams() {
            this.pageNum = 1;
            if (this.filterValue === 1 || this.filterValue === 2) {
                this.pageSize = 20;
            } else if (this.filterValue === 3) {
                this.pageSize = 40;
            } else if (this.filterValue === 4) {
                this.pageSize = 10;
            } else {
                this.pageSize = 20;
            }
            this.total = 0;
            this.pages = 1;
            this.list = []
        },
         // 获取列表数据
        getData(type) {
            console.log('type: ', type);
            this.getSearchCount(type);
            if (this.filterValue === 1) {
                this.getWorksList();
            } else if (this.filterValue === 2) {
                this.getArticleList();
            } else if (this.filterValue === 3) {
                this.getToolList();
            } else if (this.filterValue === 4) {
                this.getUserList();
            } else if (this.filterValue === 5){
                this.getMaterialList();
            } else if (this.filterValue === 6){
                this.getSourceCodeList();
            } else if (this.filterValue === 7){
                this.getImageList();
            } else if (this.filterValue === 8){
                this.getProjectCaseList();
            } else if (this.filterValue === 9){
                this.getCourseList();
            } else{
                this.loading = false;
                return;
            }
        },
        async getSearchCount(type) {
            try {
                const { data } = await getSearchCount({
                    title: this.search
                });
                
                // 不再使用固定索引，而是根据value查找对应选项
                // 为每个选项设置对应的count值
                this.filterOptions.forEach(option => {
                    switch(option.value) {
                        case 5: // 素材
                            option.count = data.material || 0;
                            break;
                        case 7: // 图片
                            option.count = data.imageCount || 0;
                            break;
                        case 1: // 作品
                            option.count = data.opus || 0;
                            break;
                        case 2: // 经验
                            option.count = data.experience || 0;
                            break;
                        case 3: // 工具
                            option.count = data.tool || 0;
                            break;
                        case 6: // 源码
                            option.count = data.sourceCode || 0;
                            break;
                        case 8: // 案例
                            option.count = data.project || 0;
                            break;
                        case 4: // 设计师
                            option.count = data.designer || 0;
                            break;
                        case 9: // 课程
                            option.count = data.course || 0; // API中没有提供课程的计数
                            break;
                    }
                });
            } catch (error) {
                console.log('error: ', error);
            }
        },
        async getWorksList() {
            try {
                let params = {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    title: this.search
                };
                const { code, data } = await getWorkSearchList(params);
                if (code === 0) {
                    const add = data.result.map(item => {
                        let category = null;
                        this.categoryList.forEach(a => {
                            if (a.value === item.type) {
                                category = a.label;
                                return;
                            }
                        });
                        return {
                            id: item.id,
                            title: item.title,
                            follow: item.viewCount,
                            collect: item.collectionCount,
                            like: item.zanCount,
                            category,
                            image: item.logo,
                            userId: item.user && item.user.id,
                            name: item.user && item.user.name,
                            avatar: item.user && item.user.imageAddress,
                            recommend: item.recommend
                        };
                    });
                    this.list = [...this.list, ...add];
                    this.total = data.total;
                    this.pages = data.pages;
                }
            } catch (err) {
                throw err;
            } finally {
                this.loading = false;
                this.scrollLoading = false;
            }
        },
        async getArticleList() {
            try {
                let params = {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    title: this.search
                };
                const { code, data } = await getArticleSearchList(params);
                if (code === 0) {
                    const add = data.result.map(item => {
                        let category = null;
                        this.categoryList.forEach(a => {
                            if (a.value === item.type) {
                                category = a.label;
                                return;
                            }
                        });
                        return {
                            id: item.id,
                            title: item.title,
                            follow: item.viewCount,
                            collect: item.collectionCount,
                            like: item.zanCount,
                            category,
                            image: item.logo,
                            userId: item.user && item.user.id,
                            name: item.user && item.user.name,
                            avatar: item.user && item.user.imageAddress,
                            recommend: item.recommend
                        };
                    });
                    this.list = [...this.list, ...add];
                    this.total = data.total;
                    this.pages = data.pages;
                }
            } catch (err) {
                throw err;
            } finally {
                this.loading = false;
                this.scrollLoading = false;
            }
        },
        async getToolList() {
            try {
                let params = {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    title: this.search
                };
                const { code, data } = await getToolSearchList(params);
                if (code === 0) {
                    const add = data.result.map(item => {
                        return {
                            id: item.id,
                            title: item.title,
                            subtitle: item.synopsis,
                            follow: item.count, // 浏览量
                            image: item.logo,
                            url: item.toolurl,
                            isabroad: item.isabroad
                        };
                    });
                    this.list = [...this.list, ...add];
                    this.total = data.total;
                    this.pages = data.pages;
                }
            } catch (err) {
                throw err;
            } finally {
                this.loading = false;
                this.scrollLoading = false;
            }
        },
        async getUserList() {
            try {
                let params = {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    name: this.search
                };
                const { code, data } = await getUserSearchList(params);
                if (code === 0) {
                    const add = data.result.map(item => {
                        return {
                            id: item.id,
                            name: item.name,
                            create: item.publishCount,
                            follow: item.fansCount,
                            avatar: item.imageAddress,
                            imageList: item.list,
                            tp: item.tp,
                            isFollow: item.isXiangHuAttention
                        };
                    });
                    this.list = [...this.list, ...add];
                    this.total = data.total;
                    this.pages = data.pages;
                }
            } catch (err) {
                throw err;
            } finally {
                this.loading = false;
                this.scrollLoading = false;
            }
        },  
        async getMaterialList() {
            try {
                let params = {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    name: this.search
                };
                
                // 添加筛选条件
                if (this.activeTab.sort && this.activeTab.sort !== '1') {
                    params.sort = this.activeTab.sort;
                }
                
                if (this.activeTab.size) {
                    params.size = this.activeTab.size;
                }
                
                if (this.activeTab.twoSort) {
                    params.twoSort = this.activeTab.twoSort;
                }
                
                if (this.activeTab.colorList && this.activeTab.colorList.length > 0) {
                    params.colorList = this.activeTab.colorList.join(',');
                }
                
                const { code, data } = await getMaterialSearchList(params);
                if (code === 0) {
                    this.list = [...this.list, ...data.result];
                    this.total = data.total;
                    this.pages = data.pages;
                }
            } catch (err) {
                throw err;
            } finally {
                this.loading = false;
                this.scrollLoading = false;
            }
        },  
        async getSourceCodeList() {
            try {
                let params = {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    title: this.search,
                };
                const { code, data, total } = await getSourceCodeList(params);
                if (code === 0) {
                    this.list = [...this.list, ...data];
                    this.total = total;
                    this.pages = Math.floor(total/this.pageNum);
                }
            } catch (err) {
                throw err;
            } finally {
                this.loading = false;
                this.scrollLoading = false;
            }
        },  
        async getImageList() {
            try {
                let params = {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    title: this.search
                };
                
                // 添加筛选条件
                if (this.activeTab.sort && this.activeTab.sort !== '1') {
                    params.sort = this.activeTab.sort;
                }
                
                if (this.activeTab.size) {
                    params.size = this.activeTab.size;
                }
                
                if (this.activeTab.price) {
                    params.price = this.activeTab.price;
                }
                
                if (this.activeTab.proportion) {
                    params.proportion = this.activeTab.proportion;
                }
                
                if (this.activeTab.colorList && this.activeTab.colorList.length > 0) {
                    params.colorList = this.activeTab.colorList.join(',');
                }
                
                const { code, data } = await getImageSearchList(params);
                if (code === 0) {
                    this.list = [...this.list, ...data.result || []];
                    this.total = data.total || 0;
                    this.pages = data.pages || 1;
                }
            } catch (err) {
                console.error('获取图片列表失败', err);
            } finally {
                this.loading = false;
                this.scrollLoading = false;
            }
        },
        async getProjectCaseList() {
            try {
                let params = {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    title: this.search
                };
                const { code, data, total } = await getProjectCaseList(params);
                if (code === 0) {
                    this.list = [...this.list, ...data];
                    this.list.forEach(item => {
                        item.formatList = item.categoryList&& item.categoryList.length ? (item.categoryList[0].techChildList || []).map(subItme => ({name:(subItme.categoryName||'').toLowerCase()})) : []
                    })
                    this.total = total;
                    this.pages = Math.floor(total/this.pageNum);
                }
            } catch (err) {
                console.error('获取项目案例列表失败', err);
            } finally {
                this.loading = false;
                this.scrollLoading = false;
            }
            },
        async getCourseList() {
            try {
                let params = {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    title: this.search
                };
                const { code, data } = await getCourseList(params);
                if (code === 0) {
                    this.list = [...this.list, ...data.result || []];
                    this.total = data.total || 0;
                    this.pages = data.pages || 1;
                }
            } catch (err) {
                console.error('获取课程列表失败', err);
            } finally {
                this.loading = false;
                this.scrollLoading = false;
            }
        },       

        // 无限滚动
        scroll() {
            if (this.pageNum > 100) return;
            if (this.pageNum >= this.pages) return;
            this.scrollLoading = true;
            this.pageNum++;
            this.getData();
        },
        // 打开详情
        openDetail(item) {
            let url = null;
            switch(this.filterValue) {
                case 1:
                    url = '/#/works/detail/';
                    break;
                case 2:
                    url = '/#/experience/detail/';
                    break;
                default:
                    break;
            }
            if (url) {
                openWindow(url + item.id);
            }
        },
        openToolDetail(item) {
            const { id, url } = item;
            this.detailId = id;
            if (!id) return;
            viewTool({ id });
            if (url) {
                openWindow(url);
                return;
            }
            openWindow('/#/tool/detail/' + id);
        },
        openUserDetail(id) {
            if (!id) return;
            this.$router.push({
                name: 'User',
                params: { id }
            });
        },
        setMaterial(material) {
			// this.material = material;
            if (!material.id) {
				return;
			}
			openWindow(`/#/material/detail/${material.id}`)
		},
        setSourceCode(sourceCode) {
			if (!sourceCode.id) {
				return;
			}
			openWindow(`/#/sourceCode/detail/${sourceCode.id}`)
		},
        setProjectCase(id) {
			if (!id) {
				return;
			}
			openWindow(`/#/projectCase/detail/${id}`)
        },
        // 获取图片尺寸列表
        async getImageSizeList() {
            try {
                const { data } = await getImageSizeList();
                this.imageSizeList = data.map(item=>({size:item, name: item}))
                console.log('获取图片尺寸数据成功:', this.imageSizeList);
            } catch (error) {
                console.log('获取图片尺寸数据失败: ', error);
            }
        },
        
        // 获取尺寸列表(素材)
        async getSizeList() {
            try {
                const { data:sizeList } = await getSizeList();
                this.materialSizeList = sizeList || [];
            } catch (error) {
                console.log('获取尺寸数据失败: ', error);
            }
        },
        
        // 获取颜色列表
        async getColorList() {
            try {
                const { data } = await getMaterialColorList();
                this.colorList = data || [];
                console.log('获取颜色数据成功:', this.colorList);
            } catch (error) {
                console.log('获取颜色数据失败:', error);
                // 如果获取失败，使用默认颜色
                this.colorList = [
                    { id: '1', name: '红色', color: '#EE4A4A' },
                    { id: '2', name: '蓝色', color: '#0E6BF6' },
                    { id: '3', name: '橙色', color: '#FD8616' },
                    { id: '4', name: '紫色', color: '#7E03F9' },
                    { id: '5', name: '黄色', color: '#FFEB3B' },
                    { id: '6', name: '黑色', color: '#000000' },
                    { id: '7', name: '绿色', color: '#029E78' },
                    { id: '8', name: '白色', color: '#FFFFFF' },
                    { id: '9', name: '青色', color: '#0AF4FC' },
                    { id: '11', name: '灰色', color: '#888888' }
                ];
            }
        },
        
        // 处理筛选条件变更
        handleDropdown(type, val) {
            console.log(`设置${type}筛选条件:`, val);
            
            // 保存旧值用于比较
            const oldValue = this.activeTab[type];
            
            // 更新筛选值
            this.activeTab[type] = val;
            
            // 更新URL查询参数
            const currentQuery = { ...this.$route.query };
            
            // 如果是默认值，从查询参数中移除
            if ((type === 'sort' && val === '1') || 
                ((type === 'size' || type === 'price' || type === 'proportion' || type === 'twoSort') && val === '')) {
                delete currentQuery[type];
            } else {
                currentQuery[type] = val;
            }
            
            // 更新路由，不触发导航守卫
            this.$router.replace({ 
                name: 'Search', 
                query: currentQuery 
            });
            
            // 重新获取数据
            this.initPageParams();
            this.getData('init');
        },
        
        // 清除筛选条件
        clearFilter(type, event) {
            // 阻止事件冒泡
            if (event) {
                event.stopPropagation();
            }
            
            console.log(`清除${type}筛选条件`);
            
            // 获取默认值
            const defaultValues = {
                sort: '1',
                size: '',
                twoSort: '',
                price: '',
                proportion: ''
            };
            
            // 更新为默认值
            this.activeTab[type] = defaultValues[type];
            
            // 更新URL查询参数
            const currentQuery = { ...this.$route.query };
            delete currentQuery[type];
            
            // 更新路由
            this.$router.replace({ 
                name: 'Search', 
                query: currentQuery 
            });
            
            // 重新获取数据
            this.initPageParams();
            this.getData('init');
        },
        
        // 设置颜色筛选
        setColor(id) {
            console.log('设置颜色筛选条件:', id);
            
            // 设置为单选模式
            this.activeTab.colorList = [id];
            
            // 更新URL查询参数
            const currentQuery = { ...this.$route.query };
            currentQuery.colorList = id;
            
            // 更新路由
            this.$router.replace({ 
                name: 'Search', 
                query: currentQuery 
            });
            
            // 重新获取数据
            this.initPageParams();
            this.getData('init');
        },
        
        // 清除颜色筛选
        clearColor(event) {
            // 阻止事件冒泡
            if (event) {
                event.stopPropagation();
            }
            
            console.log('清除颜色筛选条件');
            
            // 清空颜色列表
            this.activeTab.colorList = [];
            
            // 更新URL查询参数
            const currentQuery = { ...this.$route.query };
            delete currentQuery.colorList;
            
            // 更新路由
            this.$router.replace({ 
                name: 'Search', 
                query: currentQuery 
            });
            
            // 重新获取数据
            this.initPageParams();
            this.getData('init');
        },
        
        // 排序标签文本
        getSortLabel(val) {
            const map = {
                '1': '排序',
                '2': '最近更新',
                '5': '免费素材',
                '6': '付费素材'
            };
            return map[val] || '排序';
        },
        
        // 尺寸标签文本
        getSizeLabel(val, sizeList) {
            if (!val) return '尺寸';
            const item = sizeList.find(item => item.size === val);
            return item ? item.name : '尺寸';
        },
        
        // 价格排序标签文本
        getTwoSortLabel(val) {
            const map = {
                '': '价格',
                '1': '由高到低',
                '2': '由低到高'
            };
            return map[val] || '价格';
        },
        
        // 比例标签文本
        getProportionLabel(val) {
            const map = {
                '': '比例',
                '0': '横图',
                '1': '竖图',
                '2': '方图',
            };
            if (val === '') return '比例';
            return map[val] || '比例';
        },
    }
};
</script>

<style lang="scss">
.search-wrapper .search-input .el-input__inner {
    border-radius: 50px;
    background-color: #ECEFF8;
    border: none;
    color: #000;
    height: 40px;
    // cursor: pointer;
    border: 1px solid #A8ADC1;
}
.search-wrapper .search-input .el-input__inner::placeholder {
    color: #9398B0;
}
.search-wrapper .search-input .el-input__icon {
    line-height: 40px;
}
.search-wrapper .search-input .el-input__suffix {
    display: flex;
    align-items: center;
    right: 12px;
}
.search-wrapper .search-input .clear-icon {
    font-size: 20px;
    cursor: pointer;
    color: #9398B0;
    margin-right: 22px;
    font-weight: 600;
    &:hover {
        color: #666;
    }
}
.search-wrapper .search-input .search-btn-icon {
    font-size: 20px;
    cursor: pointer;
    color: #D8D8D8;
    font-weight: 600;
}
.search-wrapper .search-input:hover, .search-active {
    .search-btn-icon{
        color: #2F54EB!important;
    }
    .el-input__inner{
        border: 1px solid #2F54EB!important;
        background: #fff!important;
    } 
}

/* 自定义tab样式 */
.search-tabs .el-tabs__item {
    font-size: 16px;
    color: #666;
    padding: 0 14px 10px;
    position: relative;
    height: auto;
    line-height: 40px;
    margin: 0  10px;
    &:last-child {
        padding-right: 14px!important;
    }
    &:nth-child(2) {
        padding-left: 14px!important;
    }
}
.search-tabs .el-tabs__item.is-active {
    color: #2F54EB;
    font-weight: 500;
}
.search-tabs .el-tabs__active-bar {
    background-color: #2F54EB;
    height: 2px;
    bottom: 0;
}

/* 添加自定义选中效果 */
.search-tabs .el-tabs__nav {
    position: relative;
}
.search-tabs .el-tabs__item.is-active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 2px;
    background-color: #2F54EB;
}
.search-tabs .el-tabs__nav-wrap::after {
    display: none;
}
.search-tabs .el-tabs__nav-scroll {
    border-bottom: 1px solid #E0E4F7;
}

/* 自定义下拉菜单样式 */
.material-filter-container {
    display: flex;
    margin: 20px 0;
    justify-content: flex-start;
    
    .custom-dropdown {
        display: inline-block;
        font-size: 14px;
        background: #f5f6f9;
        border-radius: 4px;
        padding: 0 10px;
        height: 32px;
        line-height: 32px;
        cursor: pointer;
        border: 1px solid #DCDFE6;
        box-sizing: border-box;
        margin-right: 20px;
        vertical-align: middle;
        position: relative;
        text-align: left;
        
        &.sort-dropdown {
            width: 104px;
        }
        
        &.size-dropdown {
            width: 104px;
        }
        
        &.price-dropdown {
            width: 104px;
        }
        
        .el-dropdown-link {
            color: #606266;
            display: flex;
            align-items: center;
            font-size: 14px;
            position: relative;
            
            span, b {
                display: block;
                width: calc(100% - 15px);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-right: 5px;
            }
            
            &:hover {
                color: #2C54EF;
            }
            
            .el-icon-arrow-down {
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                font-size: 12px;
                color: #C0C4CC;
            }
            
            &.color-dropdown {
                height: 32px;
                b {
                    display: inline-flex;
                    align-items: center;
                }
            }
        }
        
        .color-icon {
            display: inline-block;
            width: 16px;
            height: 16px;
            border-radius: 100%;
            margin-right: 5px;
            &.white-color {
                border: 1px solid #DADADA;
            }
        }
        
        &:hover, &.is-selected {
            border-color: #2C54EF;
            
            .el-icon-arrow-down {
                color: #2C54EF;
            }
            
            .el-dropdown-link {
                color: #2C54EF;
            }
        }
    }
}

/* 颜色选择下拉菜单 */
.el-dropdown-menu[popper-class="find-image-dropdown"] {
    padding: 8px 5px !important;
    border: 1px solid #E4E7ED !important;
    border-radius: 4px !important;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
    min-width: 104px !important;
    
    .el-dropdown-menu__item {
        padding: 0 5px !important;
        font-size: 14px !important;
        height: 34px !important;
        line-height: 34px !important;
        border-radius: 4px !important;
        margin: 3px 0 !important; /* 增加上下间距 */
        
        &:hover {
            color: #606266 !important;
            background-color: #F5F7FA !important; /* 浅灰色背景 */
        }
        
        &.is-active {
            color: #2F54EB !important;
            background-color: #EAEEFD !important; /* 当前选中蓝色背景 */
            font-weight: 500 !important;
        }
        
        &.is-disabled {
            color: #c0c4cc !important;
        }
    }
    
    .color-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width:104px;
        padding: 7px;
    }
    
    .color-item {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 34px;
        height: 34px;
        border-radius: 100%;
        margin-bottom: 12px;
        border: 1px solid #ffffff;
        &:nth-child(2n) {
            margin-right: 0;
        }
        &:nth-last-child(1) {
            margin-bottom: 0;
        }
        &:nth-last-child(2) {
            margin-bottom: 0;
        }
        cursor: pointer;
        &.active {
            border: 1px solid #2F54EB;
        }
        .color-item-color {
            box-sizing: border-box;
            width: 26px;
            height: 26px;
            border-radius: 100%;
        }
        .white-color {
            border: 1px solid #DADADA;
        }
    }
}

.close-icon {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    font-size: 16px;
    color: #C0C4CC;
    cursor: pointer;
    
    &:hover {
        color: #939880;
    }
}
</style>

<style lang="scss" scoped>
.search-wrapper {
    position: relative;
    padding-bottom: 20px;
    background-color: #F5F7FA;
    min-height: calc(100vh - 72px);
    
    .search-container {
        padding-top: 10px;
    }
    
    .search-bar {
        display: flex;
        justify-content: center;
        align-items: center;
        
        .search-input {
            width: 500px;
        }
    }
    
    .search-tabs {
        margin-top: 30px;
        text-align: center;
        
        ::v-deep .el-tabs__nav-wrap {
            justify-content: center;
            
            .el-tabs__nav {
                float: none;
            }
        }
    }

    .search-body {
        width: 100%;
        // max-width: 1200px;
        margin: 0 auto;
        padding: 0;
        // background: #fff;
        border-radius: 4px;
        // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
        
        .search-result-total {
            height: 40px;
            line-height: 40px;
            @include font(#7B819F, 14px, 400);
        }

        .search-list-item,
        .material-list-item,
        .peoject-list-item {
            display: inline-block;
            width: 300px;
            margin-right: 20px;
            margin-top: 20px;
        }

        .designer-list {
            background-color: #fff;
            padding: 30px;
            &-item {
                &:not(:first-child) {
                    margin-top: 30px;
                }
            }
        }

        .course-container {
            margin-top: 20px;
            width: 100%;
        }
    }
}

// 小屏适配
@include mq($small) {
    .search-wrapper {
        .search-bar {
            .search-input {
                width: 300px;
            }
        }
        
        .search-body {
            width: 95%;
            
            .search-list-item,
            .material-list-item,
            .peoject-list-item {
                width: 290px;
                margin-right: 10px;
                margin-top: 10px;
            }

            .designer-list-item {
                &:not(:first-child) {
                    margin-top: 20px;
                }
            }
        }
    }
}

@include mq($smaller) {
    .search-wrapper {
        .search-bar {
            .search-input {
                width: 300px;
            }
        }
    }
}
</style>
